import React from 'react'
import { Empty } from 'antd'
import { map, isEmpty } from 'lodash'
import moment from 'moment'
import styles from '../index.scss'

// const renderData = [
//   {
//     time: '12月',
//     type: 'M',
//     text: '经传多赢天玑版、主题猎手荣获“2018年广东省优秀软件产品”称号。',
//   },
//   {
//     time: '10月',
//     type: 'M',
//     text: '经传多赢增值服务产品——价值猎手上市。',
//   },
//   {
//     time: '8月-10月',
//     type: 'M',
//     text:
//       '经传多赢名家巡讲重磅回归，力邀管清友、鲁政委、蔡英姿等著名经济学家、证券副总裁、经传多赢投顾助阵。',
//   },
//   {
//     time: '7月',
//     type: 'M',
//     text: '经传多赢首款音频产品——经点股声，正式上线。',
//   },
//   {
//     time: '6月',
//     type: 'M',
//     text: '经传多赢荣获“2017年度广东省守合同重信用企业”称号。',
//   },
//   {
//     time: '5月',
//     type: 'M',
//     text: '经传多赢经选策略正式上线。',
//   },
//   {
//     time: '',
//     type: 'M',
//     text:
//       '经传多赢与华南理工大学经贸学院，正式成立金融科技联合实验室及学生实践基地。',
//   },
//   {
//     time: '4月',
//     type: 'M',
//     text: '经传多赢首款投教产品——经点投教，正式上线。',
//   },
//   {
//     time: '2018年',
//     type: 'Y',
//   },
//   {
//     time: '6月',
//     type: 'M',
//     text: '经传多赢天玑版上市',
//   },
//   {
//     time: '5月',
//     type: 'M',
//     text: '获得沪、深交易所Level2行情数据授权',
//   },
//   {
//     time: '2月',
//     type: 'M',
//     text: '首款股民线上交流平台——股事汇app上线',
//   },
//   {
//     time: '2017年',
//     type: 'Y',
//   },
//   {
//     time: '11月',
//     type: 'M',
//     text: '上线深交所新一代V5行情 / 获得国家高新技术企业认定',
//   },
//   {
//     time: '9月',
//     type: 'M',
//     text: '经传多赢投顾手机版上市',
//   },
//   {
//     time: '',
//     type: 'M',
//     text:
//       '经传多赢财经名家巡讲再次启动，邀请任泽平、杨德龙、连平、樊纲、朱平等金融界顶级大佬助阵。',
//   },
//   {
//     time: '4月',
//     type: 'M',
//     text: '经传多赢新版OA上市',
//   },
//   {
//     time: '3月',
//     type: 'M',
//     text: '经传多赢投顾PC版上市',
//   },
//   {
//     time: '2016年',
//     type: 'Y',
//   },
//   {
//     time: '10月',
//     type: 'M',
//     text: '经传多赢巡航版上市',
//   },
//   {
//     time: '9月',
//     type: 'M',
//     text: '证券投资咨询牌照迁址广州',
//   },
//   {
//     time: '2015年',
//     type: 'Y',
//   },
//   {
//     time: '2月',
//     type: 'M',
//     text: '经传多赢领航版上市',
//   },
//   {
//     time: '1月',
//     type: 'M',
//     text: '经传多赢启航版上市',
//   },
//   {
//     time: '2014年',
//     type: 'Y',
//   },
//   {
//     time: '7月',
//     type: 'M',
//     text: '全资收购深圳智多盈，获得投资咨询资格，全面进入金融服务业',
//   },
//   {
//     time: '2013年',
//     type: 'Y',
//   },
//   {
//     time: '12月',
//     type: 'M',
//     text: '成为广东省软件协会会员单位',
//   },
//   {
//     time: '3月',
//     type: 'M',
//     text:
//       '启动中小投资者教育巡讲活动，邀请叶檀、龚方雄、李大霄、但斌等国内知名专家参与',
//   },
//   {
//     time: '1月',
//     type: 'M',
//     text:
//       '增资参股深圳大德汇富咨询顾问有限公司，财经门户网站“经传汇富”成功上线',
//   },
//   {
//     time: '2012年',
//     type: 'Y',
//   },
//   {
//     time: '7月',
//     type: 'M',
//     text:
//       '获得沪、深交易所Level-1行情数据授权 / 自主研发的经传证券辅助决策软件经典版、手机版等产品全面面市',
//   },
//   {
//     time: '2010年',
//     type: 'Y',
//   },
//   {
//     time: '12月',
//     type: 'M',
//     text: '推出水手版、波段王、旗舰版',
//   },
//   {
//     time: '2007年',
//     type: 'Y',
//   },
//   {
//     time: '9月',
//     type: 'M',
//     text: '创建软件自主研发团队',
//   },
//   {
//     time: '2006年',
//     type: 'Y',
//   },
//   {
//     time: '5月',
//     type: 'M',
//     text: '发明海洋系列市场指标',
//   },
//   {
//     time: '2001年',
//     type: 'Y',
//   },
// ]
// 时间轴展示组件
const TimeTree = props => {
  // console.log('props', props)
  // 格式化时间
  function formatDate(date, type): any {
    return moment(date).format(type)
  }

  // 比较年份 || 月份
  function diffTime(one: any, two: any, type?: any): any {
    const formatType = type || 'YYYY'
    const ONE = moment(one).format(formatType)
    const TWO = moment(two).format(formatType)

    if (ONE === TWO) {
      return true
    } else {
      return false
    }
  }

  return (
    <div className={styles.list}>
      {!isEmpty(props.data) ? (
        map(props.data, (itm, idx) => {
          if (!idx) {
            // 首个渲染为年份节点
            return (
              <>
                <div
                  key={itm.id + 'year'}
                  className={`${styles.item} ${styles.year}`}
                >
                  <span className={styles.time}>
                    {formatDate(itm.date, 'YYYY')}年
                  </span>
                  <span className={styles.line}></span>
                </div>
                <div key={itm.id + 'month'} className={styles.item}>
                  <span className={styles.time}>
                    {formatDate(itm.date, 'M')}月
                  </span>
                  <span className={styles.text}>{itm.brief}</span>
                  <span className={styles.line}></span>
                </div>
              </>
            )
          } else if (diffTime(itm.date, props.data[Number(idx) - 1].date)) {
            // 年份相同的渲染为月份节点
            // 年份相同再判断月份是否相同，月份相同不再显示相同月份
            if (diffTime(itm.date, props.data[Number(idx) - 1].date, 'M')) {
              return (
                <div key={itm.id + 'month'} className={styles.item}>
                  <span className={styles.time}></span>
                  <span className={styles.text}>{itm.brief}</span>
                  <span className={styles.line}></span>
                </div>
              )
            }
            return (
              <div key={itm.id + 'month'} className={styles.item}>
                <span className={styles.time}>
                  {formatDate(itm.date, 'M')}月
                </span>
                <span className={styles.text}>{itm.brief}</span>
                <span className={styles.line}></span>
              </div>
            )
          } else if (!diffTime(itm.date, props.data[Number(idx) - 1].date)) {
            // 年份不同的渲染成年份节点
            return (
              <>
                <div
                  key={itm.id + 'year'}
                  className={`${styles.item} ${styles.year}`}
                >
                  <span className={styles.time}>
                    {formatDate(itm.date, 'YYYY')}
                  </span>
                  <span className={styles.line}></span>
                </div>
                <div key={itm.id + 'month'} className={styles.item}>
                  <span className={styles.time}>
                    {formatDate(itm.date, 'M')}月
                  </span>
                  <span className={styles.text}>{itm.brief}</span>
                  <span className={styles.line}></span>
                </div>
              </>
            )
          }
        })
      ) : (
        <Empty />
      )}
    </div>
  )
}

export default TimeTree
